module.exports = __webpack_public_path__ + "img/notview-jddetails.02909403.svg";